import { useQuery } from "@tanstack/react-query";

import { ApiError, api } from "@/services/api";

import type { HealthResponse } from "./types";

const HEALTH_POLL_MS = 10_000;

function isHealthResponse(value: unknown): value is HealthResponse {
  return typeof value === "object" && value !== null && "checks" in value && "status" in value;
}

/**
 * Polls GET /api/health/. A 503 still carries a useful body (which dependency
 * failed), so it's returned as data rather than treated as a hard error.
 */
export function useHealth() {
  return useQuery({
    queryKey: ["system", "health"],
    queryFn: async ({ signal }): Promise<HealthResponse> => {
      try {
        return await api.get<HealthResponse>("/health/", { signal });
      } catch (error) {
        if (error instanceof ApiError && error.status === 503 && isHealthResponse(error.data)) {
          return error.data;
        }
        throw error;
      }
    },
    refetchInterval: HEALTH_POLL_MS,
    retry: false,
  });
}